import { render, staticRenderFns } from "./TabletPrint.vue?vue&type=template&id=77dc35e6"
import script from "./TabletPrint.vue?vue&type=script&lang=js"
export * from "./TabletPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports